<div class="tag-container" [class]="getEffectiveSeverityClass()">
  <span class="circle"></span>
  <span class="text">{{ text }}</span>
</div>
